import Scriba from 'react-scriba';

export class DataProgramme {

    static _chargementProgrammePerimetreEiffage(idRegion, idAgence, filtreSurMonPerimetre) {
        const objet = { idRegion, idAgence, filtreSurMonPerimetre };
        const url = "api/Liste/ListeDesProgrammes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementProgrammes(idRegion, idAgence) {
        const objet = { idRegion, idAgence };
        const url = "api/Liste/ListeDesProgrammes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    /**
     * YD : ajout idRegion et idAgence
     * @param {any} idProgramme
     * @param {any} idRegion
     * @param {any} idAgence
     */
    static _chargementProgramme(idProgramme, idRegion, idAgence) {
        const objet = { idProgramme, idRegion, idAgence };
        const url = "api/Get/GetProgramme";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementProgramme(programme) {
        const url = "api/MAJDonnees/EnregistrementProgramme";
        const paramPost = Scriba.fetch().createParameterPost(programme);
        return fetch(url, paramPost).then(response => response.json());
    };

    // KP - 28/12/2021 - Méthode dédié car modifie les clefs primaires, et nécessite donc un traitement particulier
    static _onEnregistrementProgrammeNomenclature(programme, idProgramme, idRegion, idAgence) {
        const objet = { programme, idProgramme, idRegion, idAgence };
        const url = "api/MAJDonnees/EnregistrementProgrammeNomenclature";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementProgrameOperisNomenclature(idProgramme) {
        const objet = { idProgramme };
        var url = "api/Liste/ListeOperisNomenclature";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheProgrameOperisNomenclature(idNomenclature) {
        const objet = { idNomenclature };
        var url = "api/Fiche/FicheOperisNomenclature";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementOperisNomenclature(nomenclature) {
        const url = "api/MAJDonnees/EnregistrementOperisNomenclatureDuProgramme";
        const paramPost = Scriba.fetch().createParameterPost(nomenclature);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionOperisNomenclature(idNomenclature) {
        const objet = { idNomenclature };

        var url = "api/MAJDonnees/SuppressionOperisNomenclatureDuProgramme";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}